module.exports = __webpack_public_path__ + "static/media/1.60fa54e7.jpeg";